import Plyr from 'plyr'
import domReady from '../utils/domReady';
const media = () => {
    domReady(() => {
        const i18n = {
            restart: 'Neustart',
            rewind: '{seektime}s zurückspulen',
            play: 'Abspielen',
            pause: 'Pause',
            fastForward: '{seektime}s vorspulen',
            seek: 'Seek',
            seekLabel: '{currentTime} von {duration}',
            played: 'Abgespielt',
            buffered: 'Geladen',
            currentTime: 'Aktuelle Zeit',
            duration: 'Dauer',
            volume: 'Lautstärke',
            mute: 'Stumm',
            unmute: 'Stummschaltung aufheben',
            enableCaptions: 'Untertitel aktivieren',
            disableCaptions: 'Untertitel deativieren',
            download: 'Herunterladen',
            enterFullscreen: 'Vollbild',
            exitFullscreen: 'Vollbild verlassen',
            frameTitle: 'Player für {title}',
            captions: 'Untertitel',
            settings: 'Einstellungen',
            pip: 'Bild in Bild',
            menuBack: 'Zum vorherigen Menü zurückkehren',
            speed: 'Geschwindigkeit',
            normal: 'Normal',
            quality: 'Qualität',
            loop: 'Schleife',
            start: 'Start',
            end: 'Ende',
            all: 'Alle',
            reset: 'Zurücksetzen',
            disabled: 'Deaktiviert',
            enabled: 'Aktiviert',
            advertisement: 'Werbung',
            qualityBadge: {
                2160: '4K',
                1440: 'HD',
                1080: 'HD',
                720: 'HD',
                576: 'SD',
                480: 'SD',
            },
        };
        const video = document.getElementById('videoPlayer');
        const audio = document.querySelector('audio');
        let player = null;
        let audioPlayer = null;
        const initPlayer = (video) => {
            player = new Plyr('#player', {
                i18n: i18n,
            });
            player.on('pause', event => {
                video.classList.remove('is-playing');
                video.classList.add('is-paused');
            });
            player.on('play', event => {
                video.classList.add('is-playing');
                video.classList.remove('is-paused');
            });
        }
        if (video) {
            initPlayer(video);
        }
        if (audio) {
            audioPlayer = new Plyr('#player', {
                i18n: i18n,
            });

            return audioPlayer
        }
    })
}
media()
